import { render } from "./SideNav.vue?vue&type=template&id=2d3c1f9a"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gerardo\\source\\repos\\Dorapp Web\\Dorapp Web\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__